module.exports = __webpack_public_path__ + "a621b2d7f352d9bea0ba2e7dfc00f2f7.ttf";